export const BUTTON_POSITION = {
  // 求人PR（上）※下部追従ボタン、応募促進モーダルも含む
  prTop: '8',
  // 募集要項（上）
  requirementTop: '9',
  // セミナー会社説明会
  seminarCompany: '17',
  // セミナー個別相談会
  seminarPrivate: '18',
  // 求人PR（下）
  prBottom: '19',
  // 募集要項（下）
  requirementBottom: '20',
  // 一覧
  list: '3',
} as const;

export const ENTRY_ID = {
  // 転職支援応募
  support: '1',
  // 直接応募
  direct: '25',
} as const;
